import React, { Component } from 'react';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import { InputInline } from 'app/components/Basics';
import { TabBar } from 'app/components/Basics';
import TabQuestions from '../TabQuestions/TabQuestionsComponent';
import TabProgramSelection from '../TabProgramSelection/TabProgramSelectionComponent';
import { IndepthSetFormContext } from '../../InDepthContext';
import './FilterSetCardComponent.scss';

class FilterSetCard extends Component {

    static contextType = IndepthSetFormContext;

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'questions'
        };
    }

    getTabs() {
        return [
            { id: "questions", label: 'Questions', url: 'questions', disabled: false, error: false },
            { id: "programSelection", label: 'Program Selection', url: 'programSelection', disabled: false }
        ];
    }

    toggleExpanded() {
        this.props.onToggleExpand();
    }

    onNameChange(isEditorOpen, newName) {
        if (!isEditorOpen && newName) {
            this.props.onFilterSetNameChange(this.props.filterSetIndex, newName);
        }
    }

    render() {
        const { filterSet, filterSetIndex, onDeleteFilterSet, metadata, errors, isAskAlwaysEnabled } = this.props;
        const questionCount = filterSet.questions ? filterSet.questions.length : 0;

        return (
            <div className="FilterSetCard">
                <div className="filter-set-header" onClick={() => this.toggleExpanded()}>
                    <div className="filter-set-header-left">
                        <ButtonIcon
                            icon={Icons.ChevronRight}
                            className={`expand-icon ${this.props.expanded ? 'expanded' : ''}`}
                        />
                        <InputInline
                            disabled={!this.context.canChangeData}
                            enableOnBlur
                            className="filter-set-name-input"
                            value={filterSet.name || 'New Filter Set'}
                            onModeChange={this.onNameChange.bind(this)}
                            maxLength={100}
                        />
                        <span className="filter-set-question-count">({questionCount} questions)</span>
                    </div>
                    <div className="filter-set-header-right">
                        {this.context.canChangeData && !this.context.isNetQuestSurvey && (
                            <ButtonIcon
                                icon={Icons.Delete}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteFilterSet(filterSetIndex);
                                }}
                            />
                        )}
                    </div>
                </div>

                {this.props.expanded && (
                    <div className="filter-set-content">
                        <div className="tab-bar" onClickCapture={(e) => { if (e.target.closest('a')) e.preventDefault(); }}>
                            <TabBar
                                key={`FilterSetCard-${filterSetIndex}`}
                                activeTab={this.state.activeTab}
                                tabs={this.getTabs()}
                                onTabActivate={item => this.setState({ activeTab: item.id })}
                            />
                        </div>
                        <div className="section-content">
                            {this.state.activeTab === 'questions' && (
                                <TabQuestions
                                    errors={errors}
                                    isAskAlwaysEnabled={isAskAlwaysEnabled}
                                    filterSetIndex={filterSetIndex}
                                />
                            )}
                            {this.state.activeTab === 'programSelection' && (
                                <TabProgramSelection
                                    metadata={metadata}
                                    errors={errors}
                                    filterSetIndex={filterSetIndex}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default FilterSetCard;
